import {
  ALERT_VIEWED,
  CLICK_ADD_USER_STEP1_CANCEL,
  CLICK_ADD_USER_STEP2_CANCEL,
  CLICK_ADD_USER_STEP2_SUBMIT,
  CLICK_ADD_USER_SUBMIT_SUCCESS,
  CLICK_DELETE_USER,
  CLICK_DELETE_USER_CONFIRMATION_YES,
  CLICK_EDIT_USER_CANCEL,
  CLICK_RESEND_REGISTRATION_LINK,
  CLICK_SEND_PASSWORD_RESET_LINK,
  CLICK_UPDATE_USER,
  EDIT_USER_SAVE_SUCCESS,
} from 'src/constants/tracking';
import { trackPageInteraction } from 'src/modules/analyticsTracking/trackers';

/**
 * @param {string} memberId - ID of the user the action is being performed on
 */
export const trackClickDeleteUser = (memberId: string) => {
  trackPageInteraction(CLICK_DELETE_USER, { memberId });
};

/**
 * @param {string} memberId - ID of the user the action is being performed on
 */
export const trackClickDeleteUserConfirmationYes = (memberId: string) => {
  trackPageInteraction(CLICK_DELETE_USER_CONFIRMATION_YES, {
    memberId,
  });
};

/**
 * Tracks the alert shown
 * @param {string} alertShown - Message displayed in the alert
 * @param {string} memberId - ID of the user the action is being performed on
 */
export const trackAlertShown = (alertShown: string, memberId?: string) => {
  trackPageInteraction(ALERT_VIEWED, { alertShown, memberId });
};

/**
 * @param {string} memberId - ID of the user the action is being performed on
 */
export const trackClickSendPasswordResetLink = (memberId: string) => {
  trackPageInteraction(CLICK_SEND_PASSWORD_RESET_LINK, {
    memberId,
  });
};

/**
 * @param {string} memberId - ID of the user the action is being performed on
 */
export const trackClickReSendRegistrationLink = (memberId: string) => {
  trackPageInteraction(CLICK_RESEND_REGISTRATION_LINK, {
    memberId,
  });
};

export const trackClickUpdateUser = () => {
  trackPageInteraction(CLICK_UPDATE_USER);
};

export const trackClickEditUserCancel = () => {
  trackPageInteraction(CLICK_EDIT_USER_CANCEL);
};

export const trackClickAddUserStep1Cancel = () => {
  trackPageInteraction(CLICK_ADD_USER_STEP1_CANCEL);
};

export const trackClickAddUserStep2Submit = () => {
  trackPageInteraction(CLICK_ADD_USER_STEP2_SUBMIT);
};

/**
 * @param {string} role - Role of the user being added
 * @param {string} permission - Concat of permissions given to the user
 */
export const trackAddUserSuccess = (role: string, permissions: string) => {
  trackPageInteraction(CLICK_ADD_USER_SUBMIT_SUCCESS, {
    roleSelected: role,
    permissionSelected: permissions,
  });
};

export const trackUpdateUserSuccess = (role: string, permissions: string) => {
  trackPageInteraction(EDIT_USER_SAVE_SUCCESS, {
    roleSelected: role,
    permissionSelected: permissions,
  });
};

export const trackClickAddUserStep2Cancel = () => {
  trackPageInteraction(CLICK_ADD_USER_STEP2_CANCEL);
};
